export const APP_DRAWER_TOGGLE = "APP_DRAWER_TOGGLE";
export const ERROR_MODAL_OPEN = "ERROR_MODAL_OPEN";
export const ERROR_MODAL_CLOSE = "ERROR_MODAL_CLOSE";
export const ERROR_MODAL_SET_BODY = "ERROR_MODAL_SET_BODY";
export const APP_SET_MODE = "APP_SET_MODE";
export const APP_SET_REBUILD_STATUS = "APP_SET_REBUILD_STATUS";
